import { render, staticRenderFns } from "./shadowDom.vue?vue&type=template&id=c27b9f82"
import script from "./shadowDom.vue?vue&type=script&lang=js"
export * from "./shadowDom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports